"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _useRecommendationActions = require("../../hooks/recommendation/useRecommendationActions");
var _useRecommendationHandsets = require("../../hooks/recommendation/useRecommendationHandsets");
var _useRecommendationPlans = require("../../hooks/recommendation/useRecommendationPlans");
var _useComparisonSetup = _interopRequireDefault(require("../../hooks/comparison/useComparisonSetup"));
var _useRecommendationStepper = require("../../hooks/recommendation/useRecommendationStepper");
var _useUpsellProducts = require("../../hooks/upsell/useUpsellProducts");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _shareRecommendationActions = require("../../store/shareRecommendation/shareRecommendationActions");
var _ShareRecommendation = _interopRequireDefault(require("../ShareRecommendation"));
var _useRecommendationBroadbands = require("../../hooks/recommendation/useRecommendationBroadbands");
var _useRecommendationBusinessSolutions = require("../../hooks/recommendation/useRecommendationBusinessSolutions");
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _QuestionHeader = require("../Questionnaire/QuestionHeader");
var _questionnaireActions = require("../../store/questionnaire/questionnaireActions");
var _useConfig = _interopRequireDefault(require("../../hooks/useConfig"));
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _useRecommendationNavigation = require("../../hooks/recommendation/useRecommendationNavigation");
var _useAppDispatch = require("../../hooks/useAppDispatch");
var _useAppSelector = require("../../hooks/useAppSelector");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const RecommendationFooterWrapper = (0, _styledComponents.default)('div')(props => (0, _styledComponents.css)`
    width: ${props !== null && props !== void 0 && props.showFullWidth ? '100%' : props === null || props === void 0 ? void 0 : props.width};
    padding: 0px ${props !== null && props !== void 0 && props.showFullWidth ? '35px' : '0px'};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
  `);
const RecommendationFooterWrapperItem = (0, _styledComponents.default)('div')(props => (0, _styledComponents.css)`
    ${_r10SourceLibrary.Mixins.respondTo.md(`max-width: ${props.showNextButton ? '33.33%' : '50%'}; min-width: ${props.showNextButton ? '33.33%' : '50%'}; margin: auto;`)}
  `);
const ActionButtonWrapper = _styledComponents.default.div`
  display: flex;

  @media (min-width: ${_r10SourceLibrary.themeWS10.breakpoints.md}px) {
    flex-direction: ${props => props.columnView ? 'column-reverse' : 'row'};
  }
  @media (max-width: ${_r10SourceLibrary.themeWS10.breakpoints.md}px) {
    flex-direction: column-reverse;
  }
`;
const ShareButtonWrapper = _styledComponents.default.div`
  display: flex;
  justify-content: center;
`;
const RestartButtonWrapper = _styledComponents.default.div`
  display: flex;
  justify-content: center;
`;
const RecommendationFooter = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const {
    isCheckoutInProgress,
    compareProducts
  } = (0, _useRecommendationActions.useRecommendationActions)();
  const {
    onNextStepper,
    onBackStepper,
    isFirstStep,
    isLastStep,
    currentStepObject = {}
  } = (0, _useRecommendationStepper.useRecommendationStepper)();
  (0, _useComparisonSetup.default)(currentStepObject === null || currentStepObject === void 0 ? void 0 : currentStepObject.stepType);
  const adjustActionButton = (0, _useLocalTheme.default)('recommendation.adjustActionButton', false);
  const addButtonSpacing = (0, _useLocalTheme.default)('addButtonSpacing', false);
  const showNextButton = (0, _useLocalTheme.default)('recommendation.showNextButton', false);
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const showShareButton = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectConfigShareRecommendation);
  const {
    showModalView
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectUiSettings);
  const isAirtimePlanStep = currentStepObject.stepType === 'AIRTIME_PLAN';
  const isHandsetStep = currentStepObject.stepType === 'HANDSET';
  const isBroadbandStep = currentStepObject.stepType === 'BROADBAND';
  const {
    onBack
  } = (0, _useRecommendationNavigation.useRecommendationNavigation)();
  const showStickyFooter = (0, _useConfig.default)('uiSettings.showStickyFooter', false);
  const showLoadingIndicator = (0, _useConfig.default)('showLoadingIndicator', true);
  const stickyFooterWidth = (0, _useLocalTheme.default)('recommendation.footerWidth', '100%');
  const footerWidth = showStickyFooter ? stickyFooterWidth : '100%';
  const buttonTheme = (0, _useLocalTheme.default)('button');
  const comparisonButtonText = isHandsetStep ? 'Recommendation.compareDevices' : isAirtimePlanStep ? 'Recommendation.comparePlans' : isBroadbandStep ? 'Recommendation.compareBroadbands' : 'Recommendation.compare';

  // check if Recommendation has already ButtonNext

  const recommendationNextBtnText = _services.locale.localeString('Recommendation.ButtonNext', {
    defaultValue: '',
    allowMissingKey: true
  }) || _services.locale.localeString('Questionnaire.ButtonNext');
  const nextButtonText = isAirtimePlanStep ? _services.locale.localeString('Questionnaire.ButtonChoosePlan') : recommendationNextBtnText;
  const backButtonText = 'Recommendation.BackButton';
  const RenderComparisonButton = _ref => {
    var _buttonTheme$appearan;
    let {
      buttonTheme,
      breakpoints
    } = _ref;
    return /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
      theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan = buttonTheme.appearance) === null || _buttonTheme$appearan === void 0 ? void 0 : _buttonTheme$appearan.alt1,
      mdAndBelow: breakpoints.mdAndBelow
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
      width: "full",
      state: isCheckoutInProgress ? 'disabled' : '',
      text: _services.locale.localeString(comparisonButtonText),
      onClick: () => {
        compareProducts();
      },
      appearance: adjustActionButton ? 'alt1' : 'secondary',
      dataAttributes: {
        'data-test-id': 'compare-devices-button'
      }
    }));
  };
  const RenderNextButton = _ref2 => {
    var _buttonTheme$appearan2;
    let {
      buttonTheme,
      breakpoints
    } = _ref2;
    const {
      selectedHandset
    } = (0, _useRecommendationHandsets.useRecommendationHandsets)();
    const {
      selectedPlan
    } = (0, _useRecommendationPlans.useRecommendationPlans)();
    const {
      selectedBroadband
    } = (0, _useRecommendationBroadbands.useRecommendationBroadbands)();
    const {
      selectedBusinessSolution
    } = (0, _useRecommendationBusinessSolutions.useRecommendationBusinessSolutions)();
    const {
      selectedUpsellProducts
    } = (0, _useUpsellProducts.useUpsellProducts)();
    const handleNext = () => {
      !isLastStep && onNextStepper();
      currentStepObject === null || currentStepObject === void 0 ? void 0 : currentStepObject.onNext({
        selectedHandset,
        selectedPlan,
        selectedBroadband,
        selectedUpsellProducts,
        selectedBusinessSolution
      });
    };
    return /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
      theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan2 = buttonTheme.appearance) === null || _buttonTheme$appearan2 === void 0 ? void 0 : _buttonTheme$appearan2['primary'],
      mdAndBelow: breakpoints.mdAndBelow
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
      width: "full",
      loading: isCheckoutInProgress && showLoadingIndicator,
      state: isCheckoutInProgress ? 'disabled' : '',
      text: nextButtonText,
      onClick: !isCheckoutInProgress && handleNext,
      dataAttributes: {
        'data-test-id': 'continue-button'
      }
    }));
  };
  const RenderBackButton = _ref3 => {
    var _buttonTheme$appearan3;
    let {
      buttonTheme,
      breakpoints
    } = _ref3;
    const handleBack = () => {
      isFirstStep ? onBack() : onBackStepper();
    };
    const appearanceStyle = adjustActionButton ? 'alt1' : 'secondary';
    return /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
      theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan3 = buttonTheme.appearance) === null || _buttonTheme$appearan3 === void 0 ? void 0 : _buttonTheme$appearan3[appearanceStyle],
      mdAndBelow: breakpoints.mdAndBelow
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
      width: "full",
      state: isCheckoutInProgress ? 'disabled' : '',
      text: _services.locale.localeString(backButtonText),
      onClick: !isCheckoutInProgress && handleBack,
      appearance: appearanceStyle,
      dataAttributes: {
        'data-test-id': 'back-button'
      }
    }));
  };
  return /*#__PURE__*/_react.default.createElement(RecommendationFooterWrapper, {
    width: footerWidth,
    showFullWidth: showNextButton && breakpoints.md
  }, /*#__PURE__*/_react.default.createElement(ActionButtonWrapper, {
    columnView: showModalView && !adjustActionButton
  }, showNextButton && /*#__PURE__*/_react.default.createElement(RecommendationFooterWrapperItem, {
    showNextButton: showNextButton && currentStepObject.showComparisonButton
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4,
      right: addButtonSpacing && !breakpoints.sm ? 2 : 0
    }
  }, /*#__PURE__*/_react.default.createElement(RenderBackButton, {
    breakpoints: breakpoints,
    buttonTheme: buttonTheme
  }))), currentStepObject.showComparisonButton && /*#__PURE__*/_react.default.createElement(RecommendationFooterWrapperItem, {
    showNextButton: showNextButton && currentStepObject.showComparisonButton
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4,
      left: showNextButton && addButtonSpacing && !breakpoints.sm ? 2 : 0,
      right: addButtonSpacing && !breakpoints.sm ? 2 : 0
    }
  }, /*#__PURE__*/_react.default.createElement(RenderComparisonButton, {
    breakpoints: breakpoints,
    buttonTheme: buttonTheme
  }))), /*#__PURE__*/_react.default.createElement(RecommendationFooterWrapperItem, {
    showNextButton: showNextButton && currentStepObject.showComparisonButton
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4,
      left: addButtonSpacing && !breakpoints.sm ? 2 : 0
    }
  }, /*#__PURE__*/_react.default.createElement(RenderNextButton, {
    buttonTheme: buttonTheme,
    breakpoints: breakpoints
  })))), adjustActionButton && /*#__PURE__*/_react.default.createElement(RestartButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_QuestionHeader.RestartBtnComponent, {
    isRestartVisible: true,
    onRestart: () => dispatch((0, _questionnaireActions.resetQuestionnaire)()),
    placement: "footer"
  })), isLastStep && showShareButton && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(RecommendationFooterWrapperItem, null, /*#__PURE__*/_react.default.createElement(ShareButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.LinkWithIcon, {
    appearance: "primary",
    text: _services.locale.localeString('ShareRecommendation.ButtonText'),
    icon: {
      name: 'share',
      justify: 'left',
      group: 'system',
      appearance: 'secondary'
    },
    onClick: () => dispatch((0, _shareRecommendationActions.showShareRecommendation)())
  })))), /*#__PURE__*/_react.default.createElement(_ShareRecommendation.default, null)), showStickyFooter && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 6
    }
  }));
};
var _default = RecommendationFooter;
exports.default = _default;